interface SellerPriceHistory {
  base_price: number;
  created_at: string;
}

export function consolidatePriceHistory(
  offersHistory: Record<string, SellerPriceHistory[]> | null | undefined
): { history: SellerPriceHistory[]; currentPrice: number | null } {
  if (!offersHistory) return { history: [], currentPrice: null };

  const consolidated = Object.values(offersHistory)
    .flat()
    .reduce((acc: SellerPriceHistory[], item) => {
      const sameDate = acc.find((p) => p.created_at === item.created_at);
      if (!sameDate) {
        acc.push(item);
      } else if (item.base_price < sameDate.base_price) {
        // Replace if new price is lower
        sameDate.base_price = item.base_price;
      }
      return acc;
    }, [])
    .sort(
      (a, b) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );

  return {
    history: consolidated,
    currentPrice: consolidated[consolidated.length - 1]?.base_price || null,
  };
}
